import styled from "styled-components";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "@sablier/v2-components/molecules";
import { Meta } from "@sablier/v2-components/organisms";
import { useT } from "@sablier/v2-locales";
import { vendors } from "@sablier/v2-utils";
import { Page as PagePartial } from "~/client/components";
import { pages } from "~/client/constants";
import Body from "./Body";
import Filter from "./Filter";
import Tabs from "./Tabs";
import Top from "./Top";

const Container = styled.div`
  ${(props) => props.theme.styles.contained}
  & {
    width: 100%;
    padding-bottom: 100px;

    *[data-component="table"] > div > *[data-component="header"] {
      border-top-left-radius: 0px;
    }

    *[data-component="filter"] {
      + * {
        *[data-component="table"] > div > *[data-component="header"] {
          border-top-right-radius: 0px;
        }
      }
    }
  }
`;

const Row = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    align-items: flex-start;
    width: 100%;
  }
`;

const Actions = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    column-gap: calc(${(props) => props.theme.sizes.edge} * 1);
  }
`;

const Page = styled(PagePartial)`
  ${(props) => props.theme.medias.maxLG} {
    ${Container} {
      padding-bottom: 40px;
      *[data-component="table"] > div > *[data-component="body"] {
        border-top-right-radius: 10px;
      }

      *[data-component="filter"] {
        + * {
          *[data-component="table"] > div > *[data-component="body"] {
            border-top-right-radius: 0px;
          }
        }
      }
    }
  }

  ${(props) => props.theme.medias.maxMD} {
    ${Actions} {
      position: relative;
      & > * {
        position: absolute;
        top: -64px;
        right: 0;
        p {
          white-space: nowrap;
        }
      }
    }
    ${Container} {
      *[data-component="table"] > div > *[data-component="header"] {
        border-radius: 0;
      }
      *[data-component="table"] > div > *[data-component="body"] {
        border-top-right-radius: 0px;
      }
    }
  }
`;

function Dashboard() {
  const { t } = useT();

  return (
    <Page>
      <Meta.Head title={t(pages.dashboard.locales)} />
      <Container>
        <Top />
        <Row>
          <Tabs />
          <Actions>
            <Button
              accent={"primary"}
              appearance={"gradient"}
              purpose={"internal"}
              right={PlusIcon}
              title={t("pages.createSingle")}
              titleShort={"Create"}
              onClick={() => {
                vendors.track.log("clickCreateStream");
              }}
              to={pages.gallery.builder()}
            />
          </Actions>
        </Row>
        <Filter />
        <Body />
      </Container>
    </Page>
  );
}

export default Dashboard;
